export default "__VITE_ASSET__2f4e2170__"